
export const getDateFormatDealer = (dateFormat) => {
    let format;
    
    if (dateFormat === "yyyy-MM-dd") {
       format = "YYYY-MM-DD";
    }
   else if (dateFormat === "M/d/yyyy" || dateFormat === "MM/dd/yyyy" || dateFormat === "M/dd/yyyy" || dateFormat === "MM/d/yyyy") {
        format = "L"
   }
   else {
        format = "L";
   }
    return format;
}

export const getDateFormatDealerForDatePicker = (dateFormat) => {
    let format;
    
    if (dateFormat === "yyyy-MM-dd") {
        format = "yyyy-MM-dd";
    }
    else if (dateFormat === "M/d/yyyy" || dateFormat === "MM/dd/yyyy" || dateFormat === "M/dd/yyyy" || dateFormat === "MM/d/yyyy") {
        format = "MM/dd/yyyy"
    }
    else {
        format = "MM/dd/yyyy";
    }
   
    return format;
}